import type { Episode } from '@/types/video';

interface EpisodePanelProps {
  episodes: Episode[];
  activeId: string;
  onSelect: (episode: Episode) => void;
}

export default function EpisodePanel({ episodes, activeId, onSelect }: EpisodePanelProps) {
  const active = episodes.find((item) => item.id === activeId) ?? episodes[0];

  return (
    <section className="mt-4 rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <h2 className="flex items-center gap-1.5 font-heading text-sm font-bold text-foreground-950">
          <i className="ri-play-list-line text-base text-accent-600" />
          剧集选择
        </h2>
        <span className="text-[11px] text-foreground-500">
          共 {episodes.length} 集 · 当前 {active ? active.title : '—'}
        </span>
      </div>

      <div className="mt-4 grid grid-cols-5 gap-1.5 sm:grid-cols-8 md:gap-2 lg:grid-cols-10">
        {episodes.map((episode) => {
          const isActive = episode.id === activeId;
          return (
            <button
              key={episode.id}
              type="button"
              title={episode.title}
              onClick={() => onSelect(episode)}
              className={`cursor-pointer whitespace-nowrap rounded-md border py-2 text-xs transition-colors ${
                isActive
                  ? 'border-accent-500 bg-accent-500 font-semibold text-primary-950'
                  : 'border-background-200 bg-background-100 text-foreground-700 hover:border-accent-300 hover:text-primary-600'
              }`}
            >
              {episode.number}
            </button>
          );
        })}
      </div>

      {active && (
        <p className="mt-3 rounded-md bg-background-100 px-3 py-2 text-[11px] text-foreground-500">
          <span className="font-medium text-foreground-800">{active.title}</span> · 单集时长 {active.duration}
          ，切换集数后上方播放区域会同步更新演示状态。
        </p>
      )}
    </section>
  );
}